// ** React Import
import '@styles/react/libs/flatpickr/flatpickr.scss';

import { useReactOidc } from '@axa-fr/react-oidc-context';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getOTPEmail, getOTPPhone } from '@services/PersonService';
import { IntlContext } from '@src/utility/context/Internationalization';
import { isObjEmpty, selectThemeColors } from '@utils';
import Loading from '@views/common/Loading';
import { alertCustom } from '@views/common/NotificationClient';
import { useContext, useEffect, useState } from 'react';
import { User } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { getLoginInformationLogin, verifyChangeEmail, verifyChangePhone } from '../../services/PersonService';
import { getSystemParameterByCode } from '../../services/SystemParameterService';
import { isNullOrEmpty } from './../../../src/@core/layouts/utils';
import { useParams } from 'react-router-dom';

// ** Custom Components
// ** Utils
// ** Context
// ** Third Party Components
// ** Styles
const ChangeAccountInfoIframe = () => {
    const { oidcUser, logout, login } = useReactOidc();
    const intlContext = useContext(IntlContext);
    const intl = useIntl();
    const { appId } = useParams();

    const eye = <FontAwesomeIcon icon={faEye} />
    const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />

    const headers = {
        Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
        'Accept-Language': intlContext.locale,
    };

    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        unregister,
        reset,
    } = useForm();

    const [passwordShow, setPasswordShow] = useState(false)
    const [fieldChange, setFieldChange] = useState({ value: 'email', label: `${intl.formatMessage({ id: 'email' })}` });//mặc định là email
    const [disableGetOTP, setDisableGetOTP] = useState(true)
    const [disableSaveChange, setDisableSaveChange] = useState(true)
    const [isGetOTP, setIsGetOTP] = useState(false)
    const [timeChangeEmail, setTimeChangeEmail] = useState(0)
    const [countdownChangeEmail, setCountdownChangeEmail] = useState(0)
    const [timeChangePhone, setTimeChangePhone] = useState(0)
    const [countdownChangePhone, setCountdownChangePhone] = useState(0)
    const [showEnterPassword, setShowEnterPassword] = useState(false)
    const [currentPassword, setCurrentPassword] = useState('')
    const [emailOld, setEmailOld] = useState('')
    const [emailNew, setEmailNew] = useState('')
    const [phoneOld, setPhoneOld] = useState('')
    const [phoneNew, setPhoneNew] = useState('')

    const fieldChangeOptions = [
        { value: 'email', label: `${intl.formatMessage({ id: 'email' })}` },
        { value: 'phone', label: `${intl.formatMessage({ id: 'phone' })}` },
    ];

    const [registerInfoChange, setRegisterInfoChange] = useState({ //mặc định là email
        required: `${intl.formatMessage({ id: 'requiredInfoChange' })}`,
        pattern: {
            value: /\S+@\S+\.\S+/,
            message: `Email ${intl.formatMessage({
                id: 'match',
            })} ${intl.formatMessage({ id: 'format' })}`,
        },
    });

    useEffect(() => {
        console.log('oidcUser: ', oidcUser);
        if (oidcUser) {
            login()
            getCurrentAccountInfo();
            getCountDownTime()
        } else {
            setTimeout(() => {
                logout()
                login()
            }, 1000)
        }
    }, [oidcUser]);

    // useEffect(() => {
    //     intlContext.switchLanguage(lang ?? 'vi');
    // }, [intlContext, lang]);

    const changeRegisterInfoChange = (e) => {
        unregister('infoChange');
        if (e.value === 'email') {
            setRegisterInfoChange({
                required: `${intl.formatMessage({ id: 'requiredInfoChange' })}`,
                pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: `Email ${intl.formatMessage({
                        id: 'match',
                    })} ${intl.formatMessage({ id: 'format' })}`,
                },
            });
        } else if (e.value === 'phone') {
            setRegisterInfoChange({
                required: `${intl.formatMessage({ id: 'requiredInfoChange' })}`,
                pattern: {
                    value: /^(84 + ([0-9]{8,12})|0+([0-9]{9,13}))$/,
                    message: `${intl.formatMessage({ id: 'patternSDT' })}`,
                },
            });
        }
    };

    useEffect(() => {
        let intervalId
        if (isGetOTP && countdownChangeEmail > 0) {
            intervalId = setInterval(() => {
                setCountdownChangeEmail((prevCountdown) => prevCountdown - 1)
                if (countdownChangeEmail < 2) {
                    setDisableGetOTP(false)
                }
            }, 1000)
        } else {
            setIsGetOTP(false)
            setCountdownChangeEmail(timeChangeEmail)
        }

        return () => {
            clearInterval(intervalId)
        }
    }, [isGetOTP, countdownChangeEmail])

    useEffect(() => {
        let intervalId
        if (isGetOTP && countdownChangePhone > 0) {
            intervalId = setInterval(() => {
                setCountdownChangePhone((prevCountdown) => prevCountdown - 1)
                if (countdownChangePhone < 2) {
                    setDisableGetOTP(false)
                }
            }, 1000)
        } else {
            setIsGetOTP(false)
            setCountdownChangePhone(timeChangePhone)
        }

        return () => {
            clearInterval(intervalId)
        }
    }, [isGetOTP, countdownChangePhone])

    const getCountDownTime = () => {
        getSystemParameterByCode(headers, "otp-change-email")
            .then((res) => {
                if (res?.data?.time !== null || res?.data?.time !== '') {
                    setCountdownChangeEmail(res?.data?.time)
                    setTimeChangeEmail(res?.data?.time)
                }
            })
            .catch((err) => {
                console.log(err.response);
                alertCustom("error", `${intl.formatMessage({ id: "errorGetSystemParam" })} otp-change-email`)
            })
        getSystemParameterByCode(headers, "otp-change-phone")
            .then((res) => {
                if (res?.data?.time !== null || res?.data?.time !== '') {
                    setCountdownChangePhone(res?.data?.time)
                    setTimeChangePhone(res?.data?.time)
                }
            })
            .catch((err) => {
                console.log(err.response);
                alertCustom("error", `${intl.formatMessage({ id: "errorGetSystemParam" })} otp-change-phone`)
            })
    }

    const getCurrentAccountInfo = () => {
        getLoginInformationLogin(headers, appId)
            .then((res) => {
                console.log('res: ', res);
                if (res.status == 200) {
                    setEmailOld(res.data.email)
                    setPhoneOld(res.data.phone)
                } else {
                    alertCustom("error", res.data?.message)
                }
            })
            .catch((err) => {
                alertCustom("error", err.response?.data?.message);
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const onChangeFieldChange = (e) => {
        setFieldChange(e);
        changeRegisterInfoChange(e);
    }

    const onChangeInfoChange = (value) => {
        fieldChange?.value === "email" ? setEmailNew(value) : setPhoneNew(value)
        if (!isNullOrEmpty(value)) {
            setShowEnterPassword(true)
        } else {
            setShowEnterPassword(false)
        }
    }

    const getOtp = () => {
        if (isNullOrEmpty(currentPassword)) {
            alertCustom("error", `${intl.formatMessage({ id: "accountPassword" })} ${intl.formatMessage({ id: "required" })}`)
        } else {
            if (fieldChange.value === "email") {
                if (emailOld.trim() == emailNew.trim()) {
                    alertCustom("error", `${intl.formatMessage({ id: "email" })} ${intl.formatMessage({ id: "errorNotChange" })}`)
                } else {
                    setIsGetOTP(true)
                    setDisableGetOTP(true)
                    setLoading(true)
                    getOTPEmail(headers, {
                        currentPassword,
                        emailOld: emailOld.trim(),
                        emailNew: emailNew.trim()
                    })
                        .then((res) => {
                            alertCustom("success", `${intl.formatMessage({ id: "layOtpEmail" })}`)
                            setIsGetOTP(true)
                        })
                        .catch((err) => {
                            console.log(err.response);
                            alertCustom("error", err.response?.data?.message);
                            setIsGetOTP(false)
                            setDisableGetOTP(false)
                        })
                        .finally(() => {
                            setLoading(false)
                        })
                }
            } else if (fieldChange.value === "phone") {
                if (phoneOld.trim() == phoneNew.trim()) {
                    alertCustom("error", `${intl.formatMessage({ id: "phone" })} ${intl.formatMessage({ id: "errorNotChange" })}`)
                } else {
                    setIsGetOTP(true)
                    setDisableGetOTP(true)
                    setLoading(true)
                    getOTPPhone(headers, {
                        currentPassword,
                        phoneOld: phoneOld.trim(),
                        phoneNew: phoneNew.trim()
                    })
                        .then((res) => {
                            alertCustom("success", `${intl.formatMessage({ id: "layOtpNumber" })}`)
                            setIsGetOTP(true)
                        })
                        .catch((err) => {
                            console.log(err.response);
                            alertCustom("error", err.response?.data?.message);
                            setIsGetOTP(false)
                            setDisableGetOTP(false)
                        })
                        .finally(() => {
                            setLoading(false)
                        })
                }
            }
        }
    }

    const onSubmit = (values) => {
        if (isObjEmpty(errors)) {
            setLoading(true)
            if (values.fieldChange?.value === "email") {
                verifyChangeEmail(headers, {
                    currentPassword,
                    emailOld: emailOld,
                    emailNew: values.infoChange,
                    otp: values.otp
                })
                    .then((res) => {
                        alertCustom("success", `${intl.formatMessage({ id: "successChangeAccountInfo" })}`)
                        window.parent.postMessage("success-change-email", "*")
                        // setTimeout(() => {
                        //     logout()
                        // }, 5000)
                    })
                    .catch((err) => {
                        console.log(err.response);
                        alertCustom("error", err.response?.data?.message);
                        setIsGetOTP(false)
                        setDisableGetOTP(false)
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            } else if (values.fieldChange?.value === "phone") {
                verifyChangePhone(headers, {
                    currentPassword,
                    phoneOld: emailOld,
                    phoneNew: values.infoChange,
                    otp: values.otp
                })
                    .then((res) => {
                        alertCustom("success", `${intl.formatMessage({ id: "successChangeAccountInfo" })}`)
                        window.parent.postMessage("success-change-phone", "*")
                        // setTimeout(() => {
                        //     logout()
                        // }, 5000)
                    })
                    .catch((err) => {
                        console.log(err.response);
                        alertCustom("error", err.response?.data?.message);
                        setIsGetOTP(false)
                        setDisableGetOTP(false)
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            }
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordShow(!passwordShow)
    }

    return (
        <Card>
            <CardBody style={{ height: 420 }}>
                {loading && <Loading />}
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="">
                        <Col sm="12">
                            <h5 className="mb-1">
                                <User size={20} className="mr-50" />
                                <span className="align-middle">{intl.formatMessage({ id: 'changeAccountInfo' })}</span>
                            </h5>
                        </Col>

                        <Col sm="3">
                            <FormGroup>
                                <Label className="label" for="fieldChange">
                                    {intl.formatMessage({ id: 'fieldEmailOrPhone' })}
                                </Label>
                                <span className="text-danger">*</span>
                                <Controller
                                    name="fieldChange"
                                    control={control}
                                    defaultValue={fieldChange}
                                    rules={{
                                        required: `${intl.formatMessage({
                                            id: 'requiredFieldChange',
                                        })}`,
                                    }}
                                    render={(props) => {
                                        return (
                                            <Select
                                                {...props}
                                                placeholder={intl.formatMessage({
                                                    id: 'placeholderFieldChange',
                                                })}
                                                theme={selectThemeColors}
                                                options={fieldChangeOptions}
                                                // value={fieldChange?.value}
                                                className="react-select$"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                isClearable={false}
                                                onChange={(e) => {
                                                    if (e !== undefined && e !== null) {
                                                        props.onChange(e);
                                                        onChangeFieldChange(e);
                                                    }
                                                }}
                                            />
                                        );
                                    }}
                                    invalid={errors.fieldChange && true}
                                />
                                {errors.fieldChange?.message && (
                                    <p style={{ color: 'red' }}>{errors.fieldChange?.message}</p>
                                )}
                            </FormGroup>
                        </Col>

                        <Col sm="4">
                            <div>
                                <Label className="label" for="infoCurrent">
                                    {intl.formatMessage({ id: 'infoCurrent' })}
                                </Label>
                                <span className="text-danger">*</span>
                                <Input
                                    type="text"
                                    id="infoCurrent"
                                    name="infoCurrent"
                                    disabled={true}
                                    value={fieldChange?.value === "email" ? emailOld : phoneOld}
                                />
                            </div>
                        </Col>

                        <Col sm="5">
                            <FormGroup>
                                <Label className="label" for="infoChange">
                                    {intl.formatMessage({ id: 'infoChange' })}
                                </Label>
                                <span className="text-danger">*</span>
                                <Input
                                    type="text"
                                    id="infoChange"
                                    name="infoChange"
                                    value={fieldChange?.value === "email" ? emailNew : phoneNew}
                                    onChange={(e) => onChangeInfoChange(e.target.value)}
                                    placeholder={intl.formatMessage({
                                        id: 'placeholderInfoChange',
                                    })}
                                    innerRef={register(registerInfoChange)}
                                    invalid={errors.infoChange && true}
                                />
                                {errors.infoChange?.message && (
                                    <p style={{ color: 'red' }}>{errors.infoChange?.message}</p>
                                )}
                            </FormGroup>
                        </Col>

                        {showEnterPassword ? (
                            <Col sm="12">
                                <FormGroup>
                                    <Label className="label" for="accountPassword">
                                        {intl.formatMessage({ id: 'accountPassword' })}
                                    </Label>
                                    <span className="text-danger">*</span>
                                    <Input
                                        id="accountPassword"
                                        name="accountPassword"
                                        type={passwordShow ? "text" : "password"}
                                        onChange={(e) => {
                                            setCurrentPassword(e.target.value)
                                            !isNullOrEmpty(e.target.value) ? setDisableGetOTP(false) : setDisableGetOTP(true)
                                        }}
                                        placeholder={intl.formatMessage({
                                            id: 'placeholderEnterAccountPassword',
                                        })}
                                        innerRef={register({
                                            required: `${intl.formatMessage({ id: 'requiredPassword' })}`
                                        })}
                                        invalid={errors.accountPassword && true}
                                    />
                                    {passwordShow ? <i onClick={togglePasswordVisibility} style={{ position: "absolute", cursor: "pointer", right: 45, marginTop: -29 }}>{eye}</i> : <i onClick={togglePasswordVisibility} style={{ position: "absolute", cursor: "pointer", right: 45, marginTop: -29 }}>{eyeSlash}</i>}
                                    {errors.accountPassword?.message && <p style={{ color: 'red' }}>{errors.accountPassword?.message}</p>}
                                </FormGroup>
                            </Col>
                        ) : ""}

                        <Col sm="9">
                            <FormGroup>
                                <Label className="label" for="otp">
                                    {intl.formatMessage({ id: 'otp' })}
                                </Label>
                                <span className="text-danger">*</span>
                                <Input
                                    name="otp"
                                    type={"text"}
                                    onChange={(e) => {
                                        if (!isNullOrEmpty(e.target.value)) {
                                            setDisableSaveChange(false)
                                        } else {
                                            setDisableSaveChange(true)
                                        }
                                    }}
                                    placeholder={intl.formatMessage({
                                        id: 'placeholderOtp',
                                    })}
                                    innerRef={register({
                                        required: `${intl.formatMessage({ id: 'requiredOtp' })}`
                                    })}
                                    invalid={errors.otp && true}
                                />
                                {errors.otp?.message && <p style={{ color: 'red' }}>{errors.otp?.message}</p>}
                            </FormGroup>
                        </Col>
                        <Col sm="3">
                            <Button
                                type="button"
                                color="primary"
                                style={{ marginTop: 25, display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '100%' }}
                                disabled={disableGetOTP}
                                onClick={() => getOtp()}
                            >
                                <span style={{ display: 'inline-block', width: 90 }}>
                                    {isGetOTP ?
                                        `${intl.formatMessage({ id: "nhanOTP" })} (${fieldChange.value === "email" ? countdownChangeEmail : countdownChangePhone})` :
                                        intl.formatMessage({ id: "nhanOTP" })}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                    <div className="text-right">
                        <Button
                            type="submit"
                            color="primary"
                            disabled={disableSaveChange}
                        >
                            {intl.formatMessage({ id: 'saveChange' })}
                        </Button>
                    </div>
                </Form>
            </CardBody>
        </Card>
    );
};

export default ChangeAccountInfoIframe;
